import type { NextPage } from "next"
import { NextSeo } from "next-seo"
import Link from "next/link"

import Facts from "../components/facts"

const About: NextPage = () => {
  return (
    <>
      <NextSeo
        title="Apie | Pirmas kodas"
        description="MB „Pirmas kodas“ – Kaune įsikūrusi technologijų įmonė, kurianti išmanųjį teisės asistentą „Teise.ai“."
        canonical="https://pirmaskodas.lt/about"
      />
      <article>
        <h1 className="text-3xl font-medium tracking-tight md:text-4xl">
          Apie
        </h1>
        <div className="mt-10 space-y-5">
          <p>
            MB „Pirmas kodas“ – Kaune įsikūrusi technologijų įmonė. Šiuo metu
            įgyvendiname Europos Sąjungos bendrai finansuojamą projektą, kurio
            metu kuriamas išmanusis teisės asistentas „Teise.ai“, veikiantis
            pagal pažangius kalbos modelius.
          </p>
          <p>
            <Link href="/es-projektai">Daugiau apie projektą</Link>
          </p>
          <h2 className="pt-6 text-xl font-medium tracking-tight md:text-2xl">
            Rekvizitai
          </h2>
          <Facts
            items={[
              { label: "Pavadinimas", value: "MB „Pirmas kodas“" },
              { label: "Įmonės kodas", value: "306129624" },
              {
                label: "Tel. nr.",
                value: <a href="tel:+37064139571">+370 641 39571</a>,
              },
              {
                label: "El. paštas",
                value: (
                  <a href="mailto:info@pirmaskodas.lt">info@pirmaskodas.lt</a>
                ),
              },
            ]}
          />
        </div>
      </article>
    </>
  )
}

export default About
